import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import ListFormTemplate from "../../PageTemplate/ListFormTemplate";
//import axios from 'axios';
import { config } from "../../../utils/config";
import { fetchDataAndMapToField } from "../../../utils/helperFuctions";
import useRatesLogic from "./useRatesLogic";

const columns = [
  //{ field: 'id', label: 'ID', allowSorting: false },
  {
    field: "season",
    label: "Season",
    allowSorting: true,
    subvalue: "Name",
    showInFilter: true,
  },
  {
    field: "vehicle_class",
    label: "Vehicle Category",
    allowSorting: true,
    subvalue: "name",
    showInFilter: true,
  },
  {
    field: "currency",
    label: "Currency",
    allowSorting: true,
    subvalue: "code",
  },
  { field: "daily_rate", label: "Daily rate", allowSorting: true },
  { field: "weekly_rate", label: "Weekly rate", allowSorting: true },
  { field: "monthly_rate", label: "Monthly rate", allowSorting: true },
];

const RatesPage = () => {
  const { apiRoute, addRoles, deleteRoles, editRoles, initFields } =
    useRatesLogic();
  const [fields, setfields] = useState(initFields);

  const loadOptions = async (branchId) => {
    try {
      const temp = [...initFields];

      //API endpoint to fetch the data
      // Call the function for each API endpoint
      const promises = [
        fetchDataAndMapToField(config, "vehicleclasses", "vehicle_class", temp),
        fetchDataAndMapToField(config, "seasons", "season", temp, "Name"),
        fetchDataAndMapToField(
          config,
          "currencies",
          "currency",
          temp,
          "code",
          "symbol"
        ),
      ];

      // Wait for all promises to resolve
      await Promise.all(promises);

      setfields(temp);
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  };

  useEffect(() => {
    loadOptions();
  }, []);

  return (
    <div>
      <Helmet>
        <title>Admin | Glide</title>
        <meta name="description" content="Welcome to Vehicle Rates" />
        {/* Other meta tags */}
      </Helmet>
      <ListFormTemplate
        tableNameInDb={"rate"}
        apiRoute={apiRoute}
        columns={columns}
        fields={fields}
        bringFormData={loadOptions}
        createRoles={addRoles}
        deleteRoles={deleteRoles}
        editRoles={editRoles}
        hasImport={true}
        importConfig={{
          relationshipMappings: [
            { field: "season", lookupTable: "season", lookupField: "Name" },
            { field: "vehicle_class", lookupTable: "vehicle_class", lookupField: "name" },
            { field: "currency", lookupTable: "currency", lookupField: "code" }
          ]
        }}
        enhancedTable={true}
      />
    </div>
  );
};

export default RatesPage;
